import List from "@mui/material/List";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import ActionListItem from "../components/ActionListItem";
import type { ActionsListResponse } from "../dto/actions-dto";
import { useEffect, useState } from "react";
import { getActionListRequest } from "../api/actions-api";
import { useNavigate, useParams } from "react-router-dom";


const Actions = () => {
    const { t } = useTranslation();
    const { isplanned } = useParams<{ isplanned: string }>();
    
    const [items, setItems] = useState<ActionsListResponse[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchActions = async () => {
            try {
                const data = await getActionListRequest(isplanned !== 'recent');
                setItems(data);
            } catch (err: any) {
                // Global Snackbar handles error
            }
        };

        fetchActions();
    }, [isplanned]);

    const addAction = () => {
        navigate(`/actions/new/edit`);
    };

    const handleClick = (id: number) => {
        navigate(`/actions/${id}`);
    };

    return (
        <>
            <h2 style={{ margin: 0 }}>{isplanned !== 'recent' ? t("menu.actions") : t("menu.pastActions")}</h2>

            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
                {items.map((item, index) => (
                    <ActionListItem
                        key={index}
                        firstLine={item.title}
                        secondLine={item.subtitle}
                        displayDivider={index < items.length - 1}
                        onClick={() => handleClick(item.id)}
                    />
                ))}
            </List>

            <Fab
                color="primary"
                aria-label="add"
                onClick={addAction}
                disabled={isplanned === 'recent'}
                sx={{
                    position: "fixed",
                    bottom: 24,
                    right: 24
                }}
            >
                <AddIcon />
            </Fab>
        </>
    );
};

export default Actions;